// Horizon UI Card: themed rounded container using the "Card" style config.
import { Box, useStyleConfig } from "@chakra-ui/react";

/**
 * Renders a themed Horizon card container.
 * @param {Object} props - variant + standard Box props (children, padding...)
 * @returns {React.ReactElement}
 */
export default function Card(props) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
}
